import { useEffect, useRef, useState } from "react";
import { categoryAPI } from "../../api/categoryAPI";

export default function SubCategoryTypeSearch({ setSubCatCode, setSubCatName, pCode, setIsAllSubCategoriesChecked }) {
    const [allSubCategories, setAllSubCategories] = useState([]);

    const isFirstRender = useRef(false);

    const getSubCategories = (searchKey = '') => {
        categoryAPI.getSubCategories(pCode, searchKey).then((data) => {
            setAllSubCategories(data);
        })
    }

    const handleRowSelect = (code, name) => {
        setSubCatCode(code);
        setSubCatName(name);
        setIsAllSubCategoriesChecked(false);
    }

    useEffect(() => {
        if (!isFirstRender.current) {
            isFirstRender.current = true;
            getSubCategories()
        }
    }, [])

    return (
        <div className="modal fade" id="subCategoryTypeSearch" tabIndex="-1" aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Sub-Category</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                    </div>
                    <div className="modal-body">
                        <input type="text" className="form-control" placeholder="Search by code or name"
                            onChange={(e) => getSubCategories(e.target.value)}
                        />
                        <table className="table mt-1">
                            <thead className="thead--color">
                                <tr>
                                    <th scope="col">Code</th>
                                    <th scope="col">Name</th>
                                    <th className="text-center">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {allSubCategories && allSubCategories.map(data => (
                                    <tr key={data.subCatCode}>
                                        <td>{data.subCatCode}</td>
                                        <td>{data.subCatName}</td>
                                        <td className="text-center"><button type="button" className="btn btn-sm btn-dark"
                                            onClick={() => handleRowSelect(data.subCatCode, data.subCatName)} data-bs-dismiss="modal">
                                            Select</button></td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )
}